import typography from '../typography';

export default {
  root: {
    ...typography.tablecelltext,
  }
};
